import React from 'react';
import { useTranslation } from 'react-i18next';

export const LANGUAGES = [
  { code: 'ru', label: 'Русский', country: 'Россия' },
  { code: 'en', label: 'English', country: 'United kingdom' },
];

const useChangeLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  return {
    currentLanguage: i18n.language,
    changeLanguage,
  };
};

export default useChangeLanguage;

export const withLanguageSwitcher = (WrappedComponent) =>
  function WithLanguageSwitcherWrapper(props) {
    const { currentLanguage, changeLanguage } = useChangeLanguage();
    return (
      <WrappedComponent
        {...props}
        currentLanguage={currentLanguage}
        changeLanguage={changeLanguage}
      />
    );
  };



// WEBPACK FOOTER //
// ./src/i18n/LangueageSwitcher.jsx